import { createPromiseSuspenseCache } from '@faceup/ui'

const decryptCache = createPromiseSuspenseCache()

export const useDecryptSuspense = decryptCache.usePromiseSuspense
export const clearDecryptCache = decryptCache.clear
